export default {
    login ({ commit }, credentials) {
        return window.axios
            .post('/login', credentials)
            .then(({ data }) => {
                commit('setUserData', data)
            })
    },

    logout ({ commit }) {
        commit('clearUserData')
    }
}
